// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page Loader */
.PageLoader_loader__7V0r\\+ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 1.5rem;
}

.PageLoader_spinner__4CHvi {
  display: flex;
  gap: 0.5rem;
}

.PageLoader_dot__5xYXa {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff6b9d, #7c3aed);
  animation: PageLoader_bounce__1TYmd 0.6s infinite alternate;
}

.PageLoader_dot__5xYXa:nth-child(2) {
  animation-delay: 0.2s;
  background: linear-gradient(135deg, #7c3aed, #06b6d4);
}

.PageLoader_dot__5xYXa:nth-child(3) {
  animation-delay: 0.4s;
  background: linear-gradient(135deg, #06b6d4, #ff6b9d);
}

@keyframes PageLoader_bounce__1TYmd {
  from {
    transform: translateY(0);
    opacity: 0.6;
  }
  to {
    transform: translateY(-12px);
    opacity: 1;
  }
}

.PageLoader_text__Hu6WF {
  color: var(--color-text-muted);
  font-size: 0.95rem;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/PageLoader.module.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,2DAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX","sourcesContent":["/* Page Loader */\n.loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 1.5rem;\n}\n\n.spinner {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ff6b9d, #7c3aed);\n  animation: bounce 0.6s infinite alternate;\n}\n\n.dot:nth-child(2) {\n  animation-delay: 0.2s;\n  background: linear-gradient(135deg, #7c3aed, #06b6d4);\n}\n\n.dot:nth-child(3) {\n  animation-delay: 0.4s;\n  background: linear-gradient(135deg, #06b6d4, #ff6b9d);\n}\n\n@keyframes bounce {\n  from {\n    transform: translateY(0);\n    opacity: 0.6;\n  }\n  to {\n    transform: translateY(-12px);\n    opacity: 1;\n  }\n}\n\n.text {\n  color: var(--color-text-muted);\n  font-size: 0.95rem;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `PageLoader_loader__7V0r+`,
	"spinner": `PageLoader_spinner__4CHvi`,
	"dot": `PageLoader_dot__5xYXa`,
	"bounce": `PageLoader_bounce__1TYmd`,
	"text": `PageLoader_text__Hu6WF`
};
export default ___CSS_LOADER_EXPORT___;
